import { Profile } from './Profile';

// Adding an event listener to ensure that the document's content has loaded
document.addEventListener('DOMContentLoaded', function () {
  window.requestAnimationFrame(function () {
    // Ensure that the `Webflow` property on the window object exists, if not, initialize it as an empty array
    window.Webflow ||= [];

    // Push a new function to the `Webflow` array. This function is executed when Webflow is ready.
    window.Webflow.push(async () => {
      const app = new Profile();
      app.init();
      document.documentElement.classList.add('webflow-loaded');
    });
  });
});
